export default __webpack_public_path__ + "static/figure2-de71601fd8b0bb3ac56f4e5aeaf46c37.webp";